export enum RequestStatus {
  NEW_REQUEST = 'NEW_REQUEST',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  APPROVED = 'APPROVED',
  SENT_TO_FACTORY = 'SENT_TO_FACTORY',
  IN_PRODUCTION = 'IN_PRODUCTION',
  PENDING_REGISTRATION = 'PENDING_REGISTRATION',
  REGISTERED = 'REGISTERED',
  PENDING_ASSIGNMENT = 'PENDING_ASSIGNMENT',
  PENDING_EXPEDITION = 'PENDING_EXPEDITION',
  IN_EXPEDITION = 'IN_EXPEDITION',
  IN_EXPEDITION_FACTORY = 'IN_EXPEDITION_FACTORY',
  PENDING_PICK_UP = 'PENDING_PICK_UP',
  ACTIVE = 'ACTIVE',
  CLOSED_REQUEST = 'CLOSED_REQUEST',
  CANCELLED = 'CANCELLED',
  REJECTED = 'REJECTED'
}

export enum RedPlatesStatus {
  NEW_REQUEST = 'NEW_REQUEST',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  APPROVED = 'APPROVEDL',
  ADMINISTRATIVE_PROCESSING = 'ADMINISTRATIVE_PROCESSING',
  PENDING_PICK_UP = 'PENDING_PICK_UP',
  ACTIVE = 'ACTIVE',
  PENDING_RETURN = 'PENDING_RETURN',
  RETURNED = 'RETURNED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED'
}

export enum JudgementsStatus {
  PENDING_QUALITY = 'PENDING_QUALITY',
  PENDING_AUTHORIZATION = 'PENDING_AUTHORIZATION',
  EXEC_AUTHORIZATION = 'EXEC_AUTHORIZATION',
  PENDING_GROUPPING = 'PENDING_GROUPPING',
  PENDING_SEND_TO_REC = 'PENDING_SEND_TO_REC',
  PENDING_CERTIFIED = 'PENDING_CERTIFIED',
  PENDING_INSURANCE = 'PENDING_INSURANCE',
  FINISHED = 'FINISHED'
}
